import React from 'react';
import cls from './RawHTML.module.scss';
import classNames from 'classnames';
import { ConTextAtom } from '@gandalf/babylon/atoms/text';

export type RawHTMLProps = {
  html: string;
  className?: string;
  qa?: string;
};

export const RawHTML = ({
  html,
  className,
  qa = 'html-content',
}: RawHTMLProps) => {
  return (
    <ConTextAtom qa={qa} tag="div">
      <div
        className={classNames(className, cls.container)}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </ConTextAtom>
  );
};
